export enum KYDGenreName {
  Y00s = "00s",
  Y50s = "50s",
  Y60s = "60s",
  Bit8 = "8_bit",
  Y80s = "80s",
  Y90s = "90s",
  AcidJazz = "acid_jazz",
  Acoustic = "acoustic",
  Acting = "acting",
  AfroCuban = "afro_cuban",
  AfroCaribbean = "afro_caribbean",
  AfroDance = "afro_dance",
  AfroFunk = "afro_funk",
  AfroLatino = "afro_latino",
  Afrobeat = "afrobeat",
  Afropop = "afropop",
  AfroHouse = "afro_house",
  Albanian = "albanian",
  AltCountry = "alt_country",
  AltRock = "alt_rock",
  Alternative = "alternative",
  Ambient = "ambient",
  Americana = "americana",
  Anime = "anime",
  AntiFolk = "anti_folk",
  Art = "art",
  ArtRock = "art_rock",
  Artpop = "artpop",
  Author = "author",
  AvantFunk = "avant_funk",
  AvantGarde = "avant_garde",
  AvantPop = "avant_pop",
  Bachata = "bachata",
  BaileFunk = "baile_funk",
  Balafon = "balafon",
  Balinese = "balinese",
  Balkan = "balkan",
  Bass = "bass",
  Beats = "beats",
  Bebop = "bebop",
  BedroomPop = "bedroom_pop",
  BellyDance = "belly_dance",
  Benefit = "benefit",
  Berber = "berber",
  Bhandra = "bhandra",
  Bhangra = "bhangra",
  BigBand = "big_band",
  BlackMetal = "black_metal",
  Bluegrass = "bluegrass",
  Blues = "blues",
  BoardGames = "board_games",
  Bollywood = "bollywood",
  BookLaunch = "book_launch",
  BossaNova = "bossa_nova",
  Bouyon = "bouyon",
  Brass = "brass",
  Brazilian = "brazilian",
  BritishBlues = "british_blues",
  BritishSoul = "british_soul",
  Britpop = "britpop",
  Broadway = "broadway",
  Burlesque = "burlesque",
  Cabaret = "cabaret",
  Cajun = "cajun",
  Calypso = "calypso",
  Caribbean = "caribbean",
  CaribbeanDance = "caribbean_dance",
  ChamberMusic = "chamber_music",
  ChamberPop = "chamber_pop",
  Childrens = "childrens",
  Chillout = "chillout",
  Chillwave = "chillwave",
  Chip = "chip",
  Chiptune = "chiptune",
  Choir = "choir",
  ChristianRock = "christian_rock",
  Christmas = "christmas",
  Circus = "circus",
  ClassicLatin = "classic_latin",
  ClassicHipHop = "classic_hip_hop",
  ClassicHouse = "classic_house",
  ClassicRnB = "classic_rnb",
  ClassicRockAndRoll = "classic_rock_and_roll",
  ClassicSoul = "classic_soul",
  Classical = "classical",
  Classics = "classics",
  ColdWave = "cold_wave",
  Colombian = "colombian",
  Columbian = "columbian",
  Comedy = "comedy",
  ComicBookArt = "comic_book_art",
  Congo = "congo",
  Contemporary = "contemporary",
  ContemporaryClassical = "contemporary_classical",
  Country = "country",
  Covers = "covers",
  Cretan = "cretan",
  Cuban = "cuban",
  Cumbia = "cumbia",
  Dabke = "dabke",
  Dance = "dance",
  DanceParty = "dance_party",
  DancePop = "dance_pop",
  DanceRock = "dance_rock",
  Dancehall = "dancehall",
  DarkAmbient = "dark_ambient",
  DarkWave = "dark_wave",
  DeathIndustrial = "death_industrial",
  DeathMetal = "death_metal",
  Deathcore = "deathcore",
  DeathRock = "death_rock",
  DeepHouse = "deep_house",
  Dembow = "dembow",
  DesertBlues = "desert_blues",
  DesertRock = "desert_rock",
  DholAndBrass = "dhol_and_brass",
  Disco = "disco",
  Dj = "dj",
  Djeji = "djeji",
  DoomMetal = "doom_metal",
  Downtempo = "downtempo",
  Drag = "drag",
  DreamPop = "dream_pop",
  Drone = "drone",
  DrumAndBass = "drum_and_bass",
  Dub = "dub",
  Dubstep = "dubstep",
  Ebm = "ebm",
  Edm = "edm",
  Electro = "electro",
  ElectroAcoustic = "electro_acoustic",
  ElectroPop = "electro_pop",
  Electronic = "electronic",
  Emo = "emo",
  Ethnomusicology = "ethnomusicology",
  Experimental = "experimental",
  ExperimentalNoise = "experimental_noise",
  Fashion = "fashion",
  Favela = "favela",
  Festival = "festival",
  Fiddle = "fiddle",
  Film = "film",
  FilmScores = "film_scores",
  FineArt = "fine_art",
  Flamenco = "flamenco",
  Folk = "folk",
  FolkCountry = "folk_country",
  FolkRock = "folk_rock",
  FreeJazz = "free_jazz",
  French = "french",
  Funk = "funk",
  FunkyHouse = "funky_house",
  Fusion = "fusion",
  Future = "future",
  FutureSoul = "future_soul",
  Gallery = "gallery",
  Gamelan = "gamelan",
  Games = "games",
  Gameshows = "gameshows",
  Garage = "garage",
  GarageRock = "garage_rock",
  GarifunaPunta = "garifuna_punta",
  Glam = "glam",
  Glitch = "glitch",
  GlitchHop = "glitch_hop",
  GlobalClub = "global_club",
  Gospel = "gospel",
  Goth = "goth",
  GothicRock = "gothic_rock",
  Grindcore = "grindcore",
  Griot = "griot",
  Grunge = "grunge",
  Guitar = "guitar",
  Gypsy = "gypsy",
  GypsyPunk = "gypsy_punk",
  Haitian = "haitian",
  HardDance = "hard_dance",
  HardStyle = "hard_style",
  HardTechno = "hard_techno",
  HardRock = "hard_rock",
  Hardcore = "hardcore",
  HeavyMetal = "heavy_metal",
  HipHop = "hip_hop",
  HipHopParties = "hip_hop_parties",
  House = "house",
  HyperPop = "hyper_pop",
  Idm = "idm",
  Illustration = "illustration",
  Improv = "improv",
  Indian = "indian",
  Indie = "indie",
  IndiePop = "indie_pop",
  IndieRock = "indie_rock",
  IndieFolk = "indie_folk",
  Industrial = "industrial",
  IndustrialNoise = "industrial_noise",
  Instrumental = "instrumental",
  Inuit = "inuit",
  Italo = "italo",
  Jam = "jam",
  JamBand = "jam_band",
  Jazz = "jazz",
  Journalism = "journalism",
  Juke = "juke",
  Jungle = "jungle",
  KPop = "k_pop",
  Karaoke = "karaoke",
  Kenyan = "kenyan",
  Kizomba = "kizomba",
  Klezmer = "klezmer",
  Latin = "latin",
  LatinHouse = "latin_house",
  LatinPop = "latin_pop",
  LatinSoul = "latin_soul",
  LGBTQPlus = "lgbtq_plus",
  Literature = "literature",
  LiveArt = "live_art",
  Lofi = "lofi",
  Lounge = "lounge",
  Magic = "magic",
  Mali = "mali",
  Mambo = "mambo",
  MadeAfropop = "made_afropop",
  Mariachi = "mariachi",
  MashUp = "mash_up",
  MathRock = "math_rock",
  Mbalax = "mbalax",
  Mbalakh = "mbalakh",
  Media = "media",
  MelodicHardcore = "melodic_hardcore",
  Merengue = "merengue",
  Metal = "metal",
  Metalcore = "metalcore",
  Minimal = "minimal",
  MinimalistPop = "minimalist_pop",
  MixedMedia = "mixed_media",
  Mixer = "mixer",
  Moombahton = "moombahton",
  Motown = "motown",
  Multimedia = "multimedia",
  MusicalTheatre = "musical_theatre",
  NeoRagtime = "neo_ragtime",
  NeoPsychedelic = "neo_psychedelic",
  NeoSoul = "neo_soul",
  Neoclassical = "neoclassical",
  Nerdcore = "nerdcore",
  NewWave = "new_wave",
  NoWave = "no_wave",
  Noise = "noise",
  NoisePop = "noise_pop",
  NuClassical = "nu_classical",
  NuDisco = "nu_disco",
  NuJazz = "nu_jazz",
  Opera = "opera",
  Orchestral = "orchestral",
  Pakistani = "pakistani",
  Party = "party",
  PartyRock = "party_rock",
  Percussion = "percussion",
  PerformanceArt = "performance_art",
  Persian = "persian",
  Photography = "photography",
  Piano = "piano",
  Podcast = "podcast",
  Poetry = "poetry",
  Politics = "politics",
  Pop = "pop",
  PopCulture = "pop_culture",
  PopPunk = "pop_punk",
  PopRock = "pop_rock",
  PostGenre = "post_genre",
  PostHardcore = "post_hardcore",
  PostPunk = "post_punk",
  PostRock = "post_rock",
  PostWorldbeat = "post_worldbeat",
  PowerElectronics = "power_electronics",
  PowerPop = "power_pop",
  Progressive = "progressive",
  ProgressiveMetal = "progressive_metal",
  ProgressiveRock = "progressive_rock",
  Protest = "protest",
  PsychPop = "psych_pop",
  PsychRock = "psych_rock",
  PsychSoul = "psych_soul",
  PsychePunk = "psyche_punk",
  Psychedelic = "psychedelic",
  PsychedelicRock = "psychedelic_rock",
  PsychoJazz = "psycho_jazz",
  Psychobilly = "psychobilly",
  Punk = "punk",
  RnB = "rnb",
  RnBParties = "rnb_parties",
  Ragtime = "ragtime",
  Rap = "rap",
  Reading = "reading",
  Reggae = "reggae",
  Reggaeton = "reggaeton",
  Renaissance = "renaissance",
  Retro = "retro",
  RhythmAndBlues = "rhythm_and_blues",
  Riddim = "riddim",
  Rock = "rock",
  RockAndRoll = "rock_and_roll",
  Rockabilly = "rockabilly",
  RockJazz = "rock_jazz",
  RootsReggae = "roots_reggae",
  Rumba = "rumba",
  Russian = "russian",
  SadCore = "sad_core",
  Salsa = "salsa",
  Samba = "samba",
  Saxophone = "saxophone",
  SciFi = "sci_fi",
  Science = "science",
  Semba = "semba",
  Sephardic = "sephardic",
  Shamstep = "shamstep",
  Shoegaze = "shoegaze",
  Showtunes = "showtunes",
  SingerSongwriter = "singer_songwriter",
  Ska = "ska",
  SludgeMetal = "sludge_metal",
  Soca = "soca",
  SoftRock = "soft_rock",
  Soul = "soul",
  SoulfulHouse = "soulful_house",
  SouthAsian = "south_asian",
  SpaceRock = "space_rock",
  SpaceDisco = "space_disco",
  SpokenWord = "spoken_word",
  Sports = "sports",
  StandUp = "stand_up",
  StonerMetal = "stoner_metal",
  StonerRock = "stoner_rock",
  Storytelling = "storytelling",
  StreetArt = "street_art",
  Sufi = "sufi",
  Surf = "surf",
  Swing = "swing",
  Synth = "synth",
  SynthRock = "synth_rock",
  SynthPop = "synth_pop",
  SynthWave = "synth_wave",
  Talk = "talk",
  Tango = "tango",
  TechHouse = "tech_house",
  Techno = "techno",
  Theatre = "theatre",
  ThrashMetal = "thrash_metal",
  Tipico = "tipico",
  Traditional = "traditional",
  Trance = "trance",
  TranceAndHardTrance = "trance_and_hard_trance",
  Trap = "trap",
  TripMetal = "trip_metal",
  TripHop = "trip_hop",
  Trivia = "trivia",
  Tropical = "tropical",
  TropicalBass = "tropical_bass",
  Tropicalia = "tropicalia",
  Turntablism = "turntablism",
  Variety = "variety",
  VideoGames = "video_games",
  Vinyl = "vinyl",
  VisualArt = "visual_art",
  VocalJazz = "vocal_jazz",
  Vocalist = "vocalist",
  Western = "western",
  WitchHouse = "witch_house",
  World = "world",
  Zydeco = "zydeco",
}

export enum KYDGenreLabel {
  "00s" = "00s",
  "50s" = "50s",
  "60s" = "60s",
  "8_bit" = "8 Bit",
  "80s" = "80s",
  "90s" = "90s",
  "acid_jazz" = "Acid Jazz",
  "acoustic" = "Acoustic",
  "acting" = "Acting",
  "afro_cuban" = "Afro Cuban",
  "afro_caribbean" = "Afro Caribbean",
  "afro_dance" = "Afro Dance",
  "afro_funk" = "Afro Funk",
  "afro_latino" = "Afro Latino",
  "afrobeat" = "Afrobeat",
  "afropop" = "Afropop",
  "afro_house" = "Afro House",
  "albanian" = "Albanian",
  "alt_country" = "Alt Country",
  "alt_rock" = "Alt Rock",
  "alternative" = "Alternative",
  "ambient" = "Ambient",
  "americana" = "Americana",
  "anime" = "Anime",
  "anti_folk" = "Anti Folk",
  "art" = "Art",
  "art_rock" = "Art Rock",
  "artpop" = "Artpop",
  "author" = "Author",
  "avant_funk" = "Avant Funk",
  "avant_garde" = "Avant Garde",
  "avant_pop" = "Avant Pop",
  "bachata" = "Bachata",
  "baile_funk" = "Baile Funk",
  "balafon" = "Balafon",
  "balinese" = "Balinese",
  "balkan" = "Balkan",
  "bass" = "Bass",
  "beats" = "Beats",
  "bebop" = "Bebop",
  "bedroom_pop" = "Bedroom Pop",
  "belly_dance" = "Belly Dance",
  "benefit" = "Benefit",
  "berber" = "Berber",
  "bhandra" = "Bhandra",
  "bhangra" = "Bhangra",
  "big_band" = "Big Band",
  "black_metal" = "Black Metal",
  "bluegrass" = "Bluegrass",
  "blues" = "Blues",
  "board_games" = "Board Games",
  "bollywood" = "Bollywood",
  "book_launch" = "Book Launch",
  "bossa_nova" = "Bossa Nova",
  "bouyon" = "Bouyon",
  "brass" = "Brass",
  "brazilian" = "Brazilian",
  "british_blues" = "British Blues",
  "british_soul" = "British Soul",
  "britpop" = "Britpop",
  "broadway" = "Broadway",
  "burlesque" = "Burlesque",
  "cabaret" = "Cabaret",
  "cajun" = "Cajun",
  "calypso" = "Calypso",
  "caribbean" = "Caribbean",
  "caribbean_dance" = "Caribbean Dance",
  "chamber_music" = "Chamber Music",
  "chamber_pop" = "Chamber Pop",
  "childrens" = "Children's",
  "chillout" = "Chillout",
  "chillwave" = "Chillwave",
  "chip" = "Chip",
  "chiptune" = "Chiptune",
  "choir" = "Choir",
  "christian_rock" = "Christian Rock",
  "christmas" = "Christmas",
  "circus" = "Circus",
  "classic_latin" = "Classic Latin",
  "classic_hip_hop" = "Classic Hip Hop",
  "classic_house" = "Classic House",
  "classic_rnb" = "Classic RnB",
  "classic_rock_and_roll" = "Classic Rock and Roll",
  "classic_soul" = "Classic Soul",
  "classical" = "Classical",
  "classics" = "Classics",
  "cold_wave" = "Cold Wave",
  "colombian" = "Colombian",
  "columbian" = "Columbian",
  "comedy" = "Comedy",
  "comic_book_art" = "Comic Book Art",
  "congo" = "Congo",
  "contemporary" = "Contemporary",
  "contemporary_classical" = "Contemporary Classical",
  "country" = "Country",
  "covers" = "Covers",
  "cretan" = "Cretan",
  "cuban" = "Cuban",
  "cumbia" = "Cumbia",
  "dabke" = "Dabke",
  "dance" = "Dance",
  "dance_party" = "Dance Party",
  "dance_pop" = "Dance Pop",
  "dance_rock" = "Dance Rock",
  "dancehall" = "Dancehall",
  "dark_ambient" = "Dark Ambient",
  "dark_wave" = "Dark Wave",
  "death_industrial" = "Death Industrial",
  "death_metal" = "Death Metal",
  "deathcore" = "Deathcore",
  "death_rock" = "Death Rock",
  "deep_house" = "Deep House",
  "dembow" = "Dembow",
  "desert_blues" = "Desert Blues",
  "desert_rock" = "Desert Rock",
  "dhol_and_brass" = "Dhol and Brass",
  "disco" = "Disco",
  "dj" = "DJ",
  "djeji" = "Djeji",
  "doom_metal" = "Doom Metal",
  "downtempo" = "Downtempo",
  "drag" = "Drag",
  "dream_pop" = "Dream Pop",
  "drone" = "Drone",
  "drum_and_bass" = "Drum and Bass",
  "dub" = "Dub",
  "dubstep" = "Dubstep",
  "ebm" = "EBM",
  "edm" = "EDM",
  "electro" = "Electro",
  "electro_acoustic" = "Electro Acoustic",
  "electro_pop" = "Electro Pop",
  "electronic" = "Electronic",
  "emo" = "Emo",
  "ethnomusicology" = "Ethnomusicology",
  "experimental" = "Experimental",
  "experimental_noise" = "Experimental Noise",
  "fashion" = "Fashion",
  "favela" = "Favela",
  "festival" = "Festival",
  "fiddle" = "Fiddle",
  "film" = "Film",
  "film_scores" = "Film Scores",
  "fine_art" = "Fine Art",
  "flamenco" = "Flamenco",
  "folk" = "Folk",
  "folk_country" = "Folk Country",
  "folk_rock" = "Folk Rock",
  "free_jazz" = "Free Jazz",
  "french" = "French",
  "funk" = "Funk",
  "funky_house" = "Funky House",
  "fusion" = "Fusion",
  "future" = "Future",
  "future_soul" = "Future Soul",
  "gallery" = "Gallery",
  "gamelan" = "Gamelan",
  "games" = "Games",
  "gameshows" = "Gameshows",
  "garage" = "Garage",
  "garage_rock" = "Garage Rock",
  "garifuna_punta" = "Garifuna Punta",
  "glam" = "Glam",
  "glitch" = "Glitch",
  "glitch_hop" = "Glitch Hop",
  "global_club" = "Global Club",
  "gospel" = "Gospel",
  "goth" = "Goth",
  "gothic_rock" = "Gothic Rock",
  "grindcore" = "Grindcore",
  "griot" = "Griot",
  "grunge" = "Grunge",
  "guitar" = "Guitar",
  "gypsy" = "Gypsy",
  "gypsy_punk" = "Gypsy Punk",
  "haitian" = "Haitian",
  "hard_dance" = "Hard Dance",
  "hard_rock" = "Hard Rock",
  "hard_style" = "Hard Style",
  "hard_techno" = "Hard Techno",
  "hardcore" = "Hardcore",
  "heavy_metal" = "Heavy Metal",
  "hip_hop" = "Hip Hop",
  "hip_hop_parties" = "Hip Hop (Parties)",
  "house" = "House",
  "hyper_pop" = "Hyper Pop",
  "idm" = "IDM",
  "illustration" = "Illustration",
  "improv" = "Improv",
  "indian" = "Indian",
  "indie" = "Indie",
  "indie_pop" = "Indie Pop",
  "indie_rock" = "Indie Rock",
  "indie_folk" = "Indie Folk",
  "industrial" = "Industrial",
  "industrial_noise" = "Industrial Noise",
  "instrumental" = "Instrumental",
  "inuit" = "Inuit",
  "italo" = "Italo",
  "jam" = "Jam",
  "jam_band" = "Jam Band",
  "jazz" = "Jazz",
  "journalism" = "Journalism",
  "juke" = "Juke",
  "jungle" = "Jungle",
  "k_pop" = "K-Pop",
  "karaoke" = "Karaoke",
  "kenyan" = "Kenyan",
  "kizomba" = "Kizomba",
  "klezmer" = "Klezmer",
  "latin" = "Latin",
  "latin_house" = "Latin House",
  "latin_pop" = "Latin Pop",
  "latin_soul" = "Latin Soul",
  "lgbtq_plus" = "LGBTQ+",
  "literature" = "Literature",
  "live_art" = "Live Art",
  "lofi" = "Lo-fi",
  "lounge" = "Lounge",
  "magic" = "Magic",
  "mali" = "Mali",
  "mambo" = "Mambo",
  "made_afropop" = "Made Afropop",
  "mariachi" = "Mariachi",
  "mash_up" = "Mash Up",
  "math_rock" = "Math Rock",
  "mbalax" = "Mbalax",
  "mbalakh" = "Mbalakh",
  "media" = "Media",
  "melodic_hardcore" = "Melodic Hardcore",
  "merengue" = "Merengue",
  "metal" = "Metal",
  "metalcore" = "Metalcore",
  "minimal" = "Minimal",
  "minimalist_pop" = "Minimalist Pop",
  "mixed_media" = "Mixed Media",
  "mixer" = "Mixer",
  "moombahton" = "Moombahton",
  "motown" = "Motown",
  "multimedia" = "Multimedia",
  "musical_theatre" = "Musical Theatre",
  "neo_ragtime" = "Neo Ragtime",
  "neo_psychedelic" = "Neo Psychedelic",
  "neo_soul" = "Neo Soul",
  "neoclassical" = "Neoclassical",
  "nerdcore" = "Nerdcore",
  "new_wave" = "New Wave",
  "no_wave" = "No Wave",
  "noise" = "Noise",
  "noise_pop" = "Noise Pop",
  "nu_classical" = "Nu Classical",
  "nu_disco" = "Nu Disco",
  "nu_jazz" = "Nu Jazz",
  "opera" = "Opera",
  "orchestral" = "Orchestral",
  "pakistani" = "Pakistani",
  "party" = "Party",
  "party_rock" = "Party Rock",
  "percussion" = "Percussion",
  "performance_art" = "Performance Art",
  "persian" = "Persian",
  "photography" = "Photography",
  "piano" = "Piano",
  "podcast" = "Podcast",
  "poetry" = "Poetry",
  "politics" = "Politics",
  "pop" = "Pop",
  "pop_culture" = "Pop Culture",
  "pop_punk" = "Pop Punk",
  "pop_rock" = "Pop Rock",
  "post_genre" = "Post Genre",
  "post_hardcore" = "Post Hardcore",
  "post_punk" = "Post Punk",
  "post_rock" = "Post Rock",
  "post_worldbeat" = "Post Worldbeat",
  "power_electronics" = "Power Electronics",
  "power_pop" = "Power Pop",
  "progressive" = "Progressive",
  "progressive_metal" = "Progressive Metal",
  "progressive_rock" = "Progressive Rock",
  "protest" = "Protest",
  "psych_pop" = "Psych Pop",
  "psych_rock" = "Psych Rock",
  "psych_soul" = "Psych Soul",
  "psyche_punk" = "Psyche Punk",
  "psychedelic" = "Psychedelic",
  "psychedelic_rock" = "Psychedelic Rock",
  "psycho_jazz" = "Psycho Jazz",
  "psychobilly" = "Psychobilly",
  "punk" = "Punk",
  "rnb" = "RnB",
  "rnb_parties" = "RnB (Parties)",
  "ragtime" = "Ragtime",
  "rap" = "Rap",
  "reading" = "Reading",
  "reggae" = "Reggae",
  "reggaeton" = "Reggaeton",
  "renaissance" = "Renaissance",
  "retro" = "Retro",
  "rhythm_and_blues" = "Rhythm and Blues",
  "riddim" = "Riddim",
  "rock" = "Rock",
  "rock_and_roll" = "Rock and Roll",
  "rockabilly" = "Rockabilly",
  "rock_jazz" = "Rock Jazz",
  "roots_reggae" = "Roots Reggae",
  "rumba" = "Rumba",
  "russian" = "Russian",
  "sad_core" = "Sad Core",
  "salsa" = "Salsa",
  "samba" = "Samba",
  "saxophone" = "Saxophone",
  "sci_fi" = "Sci-Fi",
  "science" = "Science",
  "semba" = "Semba",
  "sephardic" = "Sephardic",
  "shamstep" = "Shamstep",
  "shoegaze" = "Shoegaze",
  "showtunes" = "Showtunes",
  "singer_songwriter" = "Singer Songwriter",
  "ska" = "Ska",
  "sludge_metal" = "Sludge Metal",
  "soca" = "Soca",
  "soft_rock" = "Soft Rock",
  "soul" = "Soul",
  "soulful_house" = "Soulful House",
  "south_asian" = "South Asian",
  "space_rock" = "Space Rock",
  "space_disco" = "Space Disco",
  "spoken_word" = "Spoken Word",
  "sports" = "Sports",
  "stand_up" = "Stand Up",
  "stoner_metal" = "Stoner Metal",
  "stoner_rock" = "Stoner Rock",
  "storytelling" = "Storytelling",
  "street_art" = "Street Art",
  "sufi" = "Sufi",
  "surf" = "Surf",
  "swing" = "Swing",
  "synth" = "Synth",
  "synth_rock" = "Synth Rock",
  "synth_pop" = "Synth Pop",
  "synth_wave" = "Synth Wave",
  "talk" = "Talk",
  "tango" = "Tango",
  "tech_house" = "Tech House",
  "techno" = "Techno",
  "theatre" = "Theatre",
  "thrash_metal" = "Thrash Metal",
  "tipico" = "Tipico",
  "traditional" = "Traditional",
  "trance" = "Trance",
  "trance_and_hard_trance" = "Trance and Hard Trance",
  "trap" = "Trap",
  "trip_metal" = "Trip Metal",
  "trip_hop" = "Trip Hop",
  "trivia" = "Trivia",
  "tropical" = "Tropical",
  "tropical_bass" = "Tropical Bass",
  "tropicalia" = "Tropicalia",
  "turntablism" = "Turntablism",
  "variety" = "Variety",
  "video_games" = "Video Games",
  "vinyl" = "Vinyl",
  "visual_art" = "Visual Art",
  "vocal_jazz" = "Vocal Jazz",
  "vocalist" = "Vocalist",
  "western" = "Western",
  "witch_house" = "Witch House",
  "world" = "World",
  "zydeco" = "Zydeco",
}

export const KYDGenresList = Object.keys(KYDGenreName).map((key) => ({
  name: KYDGenreName[key],
  label: KYDGenreLabel[KYDGenreName[key]],
}));
